const defaultConfig = {
    slots: [
        {
            bidders: null,
            mapping: '',
            isLazyLoading: null,
            lazyLoadingPosition: null,
            description: '1x1',
            isLazyLoadingMobile: null,
            outOfPage: false,
            isNative: false,
            adServer: 'ADOCEAN',
            lazyLoadingPositionMobile: null,
            sizes: [['1', '1']],
            name: '1x1',
            zoneid: null,
            slotid: 'adoceanhubqecoetpncq',
        },
        {
            bidders: null,
            mapping: '',
            isLazyLoading: null,
            lazyLoadingPosition: null,
            description: '1x1_2',
            isLazyLoadingMobile: null,
            outOfPage: false,
            isNative: false,
            adServer: 'ADOCEAN',
            lazyLoadingPositionMobile: null,
            sizes: [['1', '1']],
            name: '1x1_2',
            zoneid: '',
            slotid: 'adoceanhubuiclcjjrte',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: false,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: false,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[1280,0],[[1220,200],[970,200],[970,100],[950,200],[950,150],[950,100],[940,200],[750,200],[750,100],[728,90],[700,150],[700,100],[1,1],"fluid"]],[[1000,0],[[970,200],[970,100],[970,90],[950,200],[950,150],[950,100],[940,200],[750,200],[750,100],[728,90],[700,150],[700,100],[1,1],"fluid"]],[[768,1],[[750,200],"fluid"]],[[0,0],[]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: true,
            lazyLoadingPosition: 100,
            description: '',
            isLazyLoadingMobile: true,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 100,
            sizes: [
                ['1', '1'],
                ['750', '200'],
                ['1220', '200'],
                ['970', '100'],
                ['970', '90'],
            ],
            floating: 0,
            disable: false,
            name: 'adsearch',
            zoneid: null,
            slotid: '',
        },
        {
            bidders: null,
            mapping: '[[[0,0],[[1,1],"fluid"]]]',
            isLazyLoading: null,
            lazyLoadingPosition: null,
            description: 'AdOcean\n_17interia > _tipy > dfp_artspons_link\n',
            isLazyLoadingMobile: null,
            outOfPage: false,
            isNative: false,
            adServer: 'ADOCEAN',
            lazyLoadingPositionMobile: null,
            sizes: [['1', '1']],
            disable: false,
            name: 'artspons_link',
            zoneid: null,
            slotid: 'adoceanhubzhinelljdz',
        },
        {
            bidders: null,
            mapping: '[[[0,0],[[1,1],"fluid"]]]',
            isLazyLoading: null,
            lazyLoadingPosition: null,
            description: 'AdOcean\n_17interia > _tipy > dfp_artspons_link2',
            isLazyLoadingMobile: null,
            outOfPage: false,
            isNative: false,
            adServer: 'ADOCEAN',
            lazyLoadingPositionMobile: null,
            sizes: [['1', '1']],
            disable: false,
            name: 'artspons_link2',
            zoneid: null,
            slotid: 'adoceanhubnmikcrenun',
        },
        {
            bidders: null,
            mapping: '[[[0,0],[[1,1],"fluid"]]]',
            isLazyLoading: null,
            lazyLoadingPosition: null,
            description: '',
            isLazyLoadingMobile: null,
            outOfPage: false,
            isNative: false,
            adServer: 'ADOCEAN',
            lazyLoadingPositionMobile: null,
            sizes: [['1', '1']],
            disable: false,
            name: 'artspons_link3',
            zoneid: '',
            slotid: 'adoceanhubskkjeseuia',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[1000,0],[[970,90],[970,250],[950,200],[950,100],[940,200],[750,200],[750,100],[728,90],[700,150],[700,100],[1,1]]],[[768,0],[[750,200],[750,100],[728,90],[700,150],[700,100],[480,200],[468,60],[1,1]]],[[360,0],[[336,400],[336,280],[320,75],[320,50],[320,125],[320,100],[300,400],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1]]],[[300,0],[[300,75],[300,50],[300,400],[300,250],[300,200],[300,100],[250,250],[240,120],[1,1]]],[[216,0],[[216,36],[200,50],[180,150],[168,28],[125,125],[120,60],[120,20],[88,31],[72,60],[1,1]]],[[0,0],[[1,1]]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: true,
            lazyLoadingPosition: 300,
            description:
                'banner umieszczony pod pierwszymi dwoma zdjęciami galerii, wyśrodkowany względem zdjęć, z funkcja przeładowania co kolejne dwa zdjęcia',
            isLazyLoadingMobile: true,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 300,
            sizes: [
                ['750', '200'],
                ['750', '100'],
                ['748', '100'],
                ['970', '90'],
                ['970', '250'],
                ['970', '100'],
                ['728', '90'],
                ['700', '150'],
                ['700', '100'],
                ['480', '75'],
                ['480', '200'],
                ['468', '60'],
                ['320', '100'],
                ['320', '125'],
                ['320', '50'],
                ['320', '75'],
                ['335', '100'],
                ['336', '280'],
                ['300', '600'],
                ['300', '50'],
                ['300', '400'],
                ['300', '250'],
                ['300', '200'],
                ['300', '100'],
                ['300', '75'],
                ['250', '250'],
                ['240', '120'],
                ['216', '36'],
                ['200', '50'],
                ['180', '150'],
                ['168', '28'],
                ['125', '125'],
                ['120', '60'],
                ['120', '20'],
                ['88', '31'],
                ['72', '60'],
                ['336', '400'],
            ],
            floating: 0,
            disable: false,
            name: 'banner_galeria',
            zoneid: {
                desktop: { zoneIds: '[1115823, 1101714]', sizes: '[[0, 1000], [1000]]' },
                mobile: { zoneIds: '[1177648, 1116731]', sizes: '[[0, 1000], [1000]]' },
            },
            slotid: '',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'smartadserver',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: false,
                            minWidth: null,
                            params: [
                                { name: 'siteId', value: 310727 },
                                { name: 'pageId', value: 1122101 },
                                { name: 'formatId', value: 67498 },
                            ],
                            maxWidth: null,
                        },
                        {
                            desktop: false,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [
                                { name: 'siteId', value: 310727 },
                                { name: 'pageId', value: 1122101 },
                                { name: 'formatId', value: 82537 },
                            ],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[768,0],[[300,600],[160,600],[120,600],[300,250],[1,1],"fluid"]],[[470,0],[[468,60],[336,400],[336,280],[320,100],[320,75],[320,50],[300,400],[300,250],[300,100],[300,75],[300,50],[1,1],"fluid"]],[[340,0],[[336,400],[336,280],[320,100],[320,75],[320,50],[300,400],[300,250],[300,100],[300,75],[300,50],[1,1],"fluid"]],[[0,0],[[300,400],[300,250],[300,100],[300,75],[300,50],[1,1],"fluid"]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: false,
            lazyLoadingPosition: 0,
            description: 'box300x250',
            isLazyLoadingMobile: false,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 0,
            sizes: [
                ['300', '250'],
                ['300', '400'],
                ['300', '600'],
                ['1', '1'],
                ['468', '60'],
                ['336', '280'],
                ['320', '100'],
                ['320', '75'],
                ['320', '50'],
                ['300', '100'],
                ['300', '75'],
                ['300', '50'],
                ['160', '600'],
                ['120', '600'],
                ['336', '400'],
            ],
            floating: 0,
            disable: false,
            name: 'box300x250',
            zoneid: {
                desktop: { zoneIds: '[1114659, 1100921]', sizes: '[[0, 1000], [1000]]' },
                mobile: { zoneIds: '[1116730, 1116730]', sizes: '[[0, 1000], [1000]]' },
            },
            slotid: '',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[768,0],[[300,600],[160,600],[120,600],[300,250],[1,1],"fluid"]],[[470,0],[[468,60],[336,400],[336,280],[320,100],[320,75],[320,50],[300,400],[300,250],[300,100],[300,75],[300,50],[1,1],"fluid"]],[[340,0],[[336,400],[336,280],[320,100],[320,75],[320,50],[300,400],[300,250],[300,100],[300,75],[300,50],[1,1],"fluid"]],[[0,0],[[300,400],[300,250],[300,100],[300,75],[300,50],[1,1],"fluid"]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: true,
            lazyLoadingPosition: 300,
            description:
                'druga kreacja w prawym sidebar na galeriach, umieszczona pod standardowym navi, która wraz ze scrollowaniem strony w dół będzie się przeładowywać co dwa zdjęcia.',
            isLazyLoadingMobile: true,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 300,
            sizes: [
                ['300', '250'],
                ['300', '600'],
                ['120', '600'],
                ['160', '600'],
                ['336', '280'],
                ['336', '400'],
            ],
            floating: null,
            disable: false,
            name: 'box300x250_galeria',
            zoneid: '1114659',
            slotid: '',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[1280,0],[[750,300],[750,200],[750,100],[625,100],[620,200],[1,1],"fluid"]],[[768,0],[[625,100],[1,1],"fluid"]],[[0,0],[[300,250],[1,1],"fluid"]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: false,
            lazyLoadingPosition: 300,
            description: 'AdOcean - box pod news',
            isLazyLoadingMobile: false,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 300,
            sizes: [
                ['625', '100'],
                ['460', '100'],
                ['620', '100'],
                ['695', '100'],
                ['748', '100'],
            ],
            floating: 0,
            disable: false,
            name: 'box625_html',
            zoneid: null,
            slotid: '',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: false,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: false,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping: '[[[980,0],[[300,600],[300,250],[1,1],"fluid"]],[[0,0],[]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: true,
            lazyLoadingPosition: 500,
            description: '',
            isLazyLoadingMobile: true,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 500,
            sizes: [
                ['300', '250'],
                ['300', '600'],
            ],
            floating: 500,
            disable: false,
            name: 'box_sidebar',
            zoneid: '',
            slotid: '',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[1280,0],[[750,100],[750,200],[700,150],[550,150],[1,1],"fluid"]],[[550,0],[[550,150],[1,1],"fluid"]],[[470,0],[[468,60],[336,400],[336,280],[320,125],[320,100],[320,75],[320,50],[300,400],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[340,0],[[336,400],[336,280],[320,125],[320,100],[320,75],[320,50],[300,400],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[300,0],[[300,400],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[240,120],[1,1],"fluid"]],[[216,0],[[216,36],[200,50],[180,150],[168,28],[125,125],[120,60],[120,20],[88,31],[72,60],[1,1],"fluid"]],[[0,0],[[1,1],"fluid"]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: true,
            lazyLoadingPosition: 0,
            description: 'skonfigurowany mapping',
            isLazyLoadingMobile: true,
            outOfPage: false,
            isNative: true,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 0,
            sizes: [
                ['700', '150'],
                ['550', '150'],
                ['468', '60'],
                ['336', '280'],
                ['320', '125'],
                ['320', '100'],
                ['320', '50'],
                ['320', '75'],
                ['300', '400'],
                ['300', '250'],
                ['300', '200'],
                ['300', '100'],
                ['300', '75'],
                ['300', '50'],
                ['250', '250'],
                ['240', '120'],
                ['216', '36'],
                ['200', '50'],
                ['180', '150'],
                ['168', '28'],
                ['125', '125'],
                ['120', '60'],
                ['120', '20'],
                ['88', '31'],
                ['72', '60'],
                ['336', '400'],
                ['750', '100'],
                ['750', '200'],
            ],
            floating: null,
            disable: false,
            name: 'commentslist',
            zoneid: {
                desktop: { zoneIds: '[1266037, 1264506]', sizes: '[[0, 700], [700]]' },
                mobile: { zoneIds: '[1116730, 1264506]', sizes: '[[0, 700], [700]]' },
            },
            slotid: '',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[1280,0],[[750,100],[750,200],[700,150],[550,150],[1,1],"fluid"]],[[550,0],[[550,150],[1,1],"fluid"]],[[470,0],[[468,60],[336,400],[336,280],[320,125],[320,100],[320,75],[320,50],[300,400],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[340,0],[[336,400],[336,280],[320,125],[320,100],[320,75],[320,50],[300,400],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[300,0],[[300,400],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[240,120],[1,1],"fluid"]],[[216,0],[[216,36],[200,50],[180,150],[168,28],[125,125],[120,60],[120,20],[88,31],[72,60],[1,1],"fluid"]],[[0,0],[[1,1],"fluid"]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: true,
            lazyLoadingPosition: 0,
            description: '',
            isLazyLoadingMobile: true,
            outOfPage: false,
            isNative: true,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 0,
            sizes: [
                ['700', '150'],
                ['550', '150'],
                ['468', '60'],
                ['336', '280'],
                ['320', '125'],
                ['320', '100'],
                ['300', '50'],
                ['300', '75'],
                ['320', '75'],
                ['320', '50'],
                ['300', '400'],
                ['300', '250'],
                ['300', '200'],
                ['300', '100'],
                ['250', '250'],
                ['240', '120'],
                ['216', '36'],
                ['200', '50'],
                ['180', '150'],
                ['168', '28'],
                ['125', '125'],
                ['120', '60'],
                ['120', '20'],
                ['88', '31'],
                ['72', '60'],
                ['336', '400'],
                ['750', '100'],
                ['750', '200'],
            ],
            floating: null,
            disable: false,
            name: 'commentslist_2',
            zoneid: {
                desktop: { zoneIds: '[1266037, 1264506]', sizes: '[[0, 700], [700]]' },
                mobile: { zoneIds: '[1116730, 1264506]', sizes: '[[0, 700], [700]]' },
            },
            slotid: '',
        },
        {
            bidders: null,
            mapping: '',
            isLazyLoading: null,
            lazyLoadingPosition: null,
            description: 'box wyświetlany na dole strony w sekcji "polecane".Emitowany z AO',
            isLazyLoadingMobile: null,
            outOfPage: false,
            isNative: false,
            adServer: 'ADOCEAN',
            lazyLoadingPositionMobile: null,
            sizes: [],
            disable: false,
            name: 'contentstream',
            zoneid: '',
            slotid: 'adoceanhubplrphpoirz',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[1280,0],[[1220,600],[1220,400],[1220,300],[985,400],[970,250],[970,90],[950,300],[950,200],[950,100],[940,300],[940,200],[750,300],[750,200],[750,100],[728,90],[700,150],[700,100],[480,200],[468,60],[1,1],"fluid"]],[[1000,0],[[940,300],[940,200],[750,300],[750,200],[750,100],[728,90],[700,150],[700,100],[480,200],[468,60],[1,1],"fluid"]],[[768,0],[[750,300],[750,200],[750,100],[728,90],[700,150],[700,100],[480,200],[468,60],[336,280],[320,125],[320,100],[320,75],[320,50],[300,600],[300,400],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[360,0],[[336,400],[336,280],[320,125],[320,100],[320,75],[320,50],[300,600],[300,400],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[300,0],[[300,75],[300,600],[300,400],[300,250],[300,200],[300,100],[300,50],[250,250],[240,120],[1,1],"fluid"]],[[216,0],[[216,36],[200,50],[180,150],[168,28],[125,125],[120,60],[120,20],[88,31],[72,60],[1,1],"fluid"]],[[0,0],[[1,1],"fluid"]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: true,
            lazyLoadingPosition: 150,
            description: 'dol_srodek',
            isLazyLoadingMobile: true,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 150,
            sizes: [
                ['750', '200'],
                ['700', '100'],
                ['985', '400'],
                ['970', '250'],
                ['970', '90'],
                ['950', '300'],
                ['950', '200'],
                ['950', '100'],
                ['940', '200'],
                ['750', '300'],
                ['750', '100'],
                ['728', '90'],
                ['700', '150'],
                ['480', '200'],
                ['468', '60'],
                ['336', '280'],
                ['320', '125'],
                ['320', '100'],
                ['320', '75'],
                ['320', '50'],
                ['300', '600'],
                ['300', '400'],
                ['300', '250'],
                ['300', '200'],
                ['300', '100'],
                ['300', '75'],
                ['300', '50'],
                ['250', '250'],
                ['240', '120'],
                ['216', '36'],
                ['200', '50'],
                ['180', '150'],
                ['168', '28'],
                ['125', '125'],
                ['120', '60'],
                ['120', '20'],
                ['88', '31'],
                ['72', '60'],
                ['940', '300'],
                ['1', '1'],
                ['336', '400'],
            ],
            floating: 0,
            disable: false,
            name: 'dol_srodek',
            zoneid: {
                desktop: { zoneIds: '[1115823, 1101714]', sizes: '[[0, 1000], [1000]]' },
                mobile: { zoneIds: '[1177648, 1116731]', sizes: '[[0, 1000], [1000]]' },
            },
            slotid: '',
        },
        {
            bidders: [],
            mapping:
                '[[[1279,0],[[695,389],[1,1],"fluid"]],[[999,0],[[620,389],[1,1],"fluid"]],[[767,0],[[748,389],[1,1],"fluid"]],[[360,0],[[312,386],[1,1],"fluid"]],[[0,0],[[280,368],[1,1],"fluid"]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: false,
            lazyLoadingPosition: 600,
            description: 'Slot dla feeda produktowego',
            isLazyLoadingMobile: false,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            lazyLoadingPositionMobile: 600,
            sizes: [
                ['1', '1'],
                ['700', '370'],
                ['550', '370'],
                ['328', '370'],
            ],
            floating: 0,
            disable: false,
            name: 'feed_grupa',
            zoneid: '',
            slotid: '',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[1280,0],[[1220,400],[1220,300],[985,400],[970,300],[970,250],[970,200],[970,100],[970,90],[950,300],[950,200],[950,150],[950,100],[940,300],[940,200],[750,300],[750,200],[750,100],[728,90],[700,150],[700,100],[1,1],"fluid"]],[[1000,0],[[985,400],[970,300],[970,250],[970,200],[970,100],[970,90],[950,300],[950,200],[950,150],[950,100],[940,300],[940,200],[750,300],[750,200],[750,100],[728,90],[700,150],[700,100],[1,1],"fluid"]],[[768,0],[[750,300],[750,200],[750,100],[728,90],[700,150],[700,100],[480,200],[468,60],[336,280],[320,125],[320,100],[320,75],[320,50],[300,300],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[360,0],[[320,75],[336,280],[320,125],[320,100],[320,50],[300,250],[300,300],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[300,0],[[300,75],[300,250],[300,300],[300,200],[300,100],[300,50],[250,250],[240,120],[1,1],"fluid"]],[[216,0],[[216,36],[200,50],[180,150],[168,28],[125,125],[120,60],[120,20],[88,31],[72,60],[1,1],"fluid"]],[[0,0],[[1,1],"fluid"]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: false,
            lazyLoadingPosition: 350,
            description: 'gora_srodek',
            isLazyLoadingMobile: false,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 350,
            sizes: [
                ['750', '200'],
                ['985', '400'],
                ['970', '90'],
                ['970', '300'],
                ['970', '250'],
                ['950', '300'],
                ['950', '200'],
                ['950', '100'],
                ['940', '200'],
                ['750', '300'],
                ['750', '100'],
                ['700', '100'],
                ['1220', '300'],
                ['940', '300'],
                ['728', '90'],
                ['700', '150'],
                ['480', '200'],
                ['468', '60'],
                ['336', '280'],
                ['320', '125'],
                ['320', '100'],
                ['320', '75'],
                ['320', '50'],
                ['300', '250'],
                ['300', '200'],
                ['300', '100'],
                ['300', '75'],
                ['300', '50'],
                ['250', '250'],
                ['240', '120'],
                ['1', '1'],
                ['950', '150'],
                ['970', '100'],
                ['300', '300'],
                ['1220', '400'],
                ['1220', '600'],
            ],
            floating: 0,
            disable: false,
            name: 'gora_srodek',
            zoneid: {
                desktop: { zoneIds: '[1115823, 1101714]', sizes: '[[0, 1000], [1000]]' },
                mobile: { zoneIds: '[1116730, 1116730]', sizes: '[[0, 1000], [1000]]' },
            },
            slotid: '',
        },
        {
            bidders: [],
            mapping: '[[[0,0],[[300,250],[336,280],[320,370],[320,480],[370,220],[480,320]]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: false,
            lazyLoadingPosition: 0,
            description: 'mobilna strona główna',
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            sizes: [
                ['320', '480'],
                ['480', '320'],
                ['768', '1024'],
                ['1024', '768'],
                ['300', '250'],
                ['336', '280'],
                ['750', '200'],
                ['750', '100'],
            ],
            disable: false,
            name: 'interstitial',
            zoneid: '',
            slotid: '',
        },
        {
            bidders: null,
            mapping: '',
            isLazyLoading: null,
            lazyLoadingPosition: null,
            description: '',
            isLazyLoadingMobile: null,
            outOfPage: false,
            isNative: false,
            adServer: 'ADOCEAN',
            lazyLoadingPositionMobile: null,
            sizes: [['950', '260']],
            floating: 0,
            disable: false,
            name: 'promocyjni_gazetka_dol',
            zoneid: null,
            slotid: 'adoceanhubzmpmojsrlp',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[1280,0],[[750,300],[750,200],[750,100],[728,90],[700,150],[700,100],[625,100],[620,200],[480,200],[468,60],[336,280],[320,125],[320,100],[320,75],[320,50],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[1000,0],[[625,100],[620,200],[620,100],[600,300],[600,200],[600,100],[560,200],[560,100],[480,200],[468,60],[336,280],[320,125],[320,100],[320,75],[320,50],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[768,0],[[728,90],[700,150],[700,100],[625,100],[620,200],[620,100],[600,300],[600,200],[600,100],[560,200],[560,100],[480,200],[468,60],[336,280],[320,125],[320,100],[320,75],[320,50],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[360,0],[[336,400],[336,280],[320,125],[320,75],[320,100],[320,50],[300,400],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[300,0],[[300,75],[300,250],[300,200],[300,100],[300,50],[250,250],[240,120],[1,1],"fluid"]],[[216,0],[[216,36],[200,50],[180,150],[168,28],[125,125],[120,60],[120,20],[88,31],[72,60],[1,1],"fluid"]],[[0,0],[[1,1],"fluid"]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: true,
            lazyLoadingPosition: 300,
            description: 'rectangle',
            isLazyLoadingMobile: true,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 300,
            sizes: [
                ['300', '250'],
                ['468', '60'],
                ['336', '280'],
                ['320', '100'],
                ['320', '75'],
                ['320', '50'],
                ['300', '400'],
                ['300', '100'],
                ['300', '75'],
                ['300', '50'],
                ['336', '400'],
            ],
            floating: null,
            disable: false,
            name: 'rectangle',
            zoneid: {
                desktop: { zoneIds: '[1114659, 1114659]', sizes: '[[0, 1000], [1000]]' },
                mobile: { zoneIds: '[1116730, 1116730]', sizes: '[[0, 1000], [1000]]' },
            },
            slotid: '',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[768,0],[[300,250],[1,1],"fluid"]],[[480,0],[[336,280],[320,100],[320,75],[320,50],[300,400],[300,250],[300,100],[300,75],[300,50],[1,1],"fluid"]],[[470,0],[[468,60],[336,280],[320,100],[320,75],[320,50],[300,400],[300,250],[300,100],[300,75],[300,50],[1,1],"fluid"]],[[340,0],[[336,280],[320,100],[320,75],[320,50],[300,400],[300,250],[300,100],[300,75],[300,50],[1,1],"fluid"]],[[0,0],[[300,400],[300,250],[300,100],[300,75],[300,50],[1,1],"fluid"]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: true,
            lazyLoadingPosition: 300,
            description: 'deccoria',
            isLazyLoadingMobile: false,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 300,
            sizes: [['300', '250']],
            floating: null,
            disable: false,
            name: 'rectangle_2',
            zoneid: {
                desktop: { zoneIds: '[1114659, 1114659]', sizes: '[[0, 1000], [1000]]' },
                mobile: { zoneIds: '[1116730, 1116730]', sizes: '[[0, 1000], [1000]]' },
            },
            slotid: '',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: true,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[1280,0],[[750,300],[750,200],[750,100],[728,90],[700,150],[700,100],[620,200],[480,200],[468,60],[336,280],[320,125],[320,100],[320,75],[320,50],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[1000,0],[[625,100],[620,200],[620,100],[600,300],[600,200],[600,100],[560,200],[560,100],[480,200],[468,60],[336,280],[320,125],[320,100],[320,75],[320,50],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[768,0],[[728,90],[700,150],[700,100],[625,100],[620,200],[620,100],[600,300],[600,200],[600,100],[560,200],[560,100],[480,200],[468,60],[336,280],[320,125],[320,100],[320,75],[320,50],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[360,0],[[336,400],[336,280],[320,125],[320,75],[320,100],[320,50],[300,400],[300,250],[300,200],[300,100],[300,75],[300,50],[250,250],[1,1],"fluid"]],[[300,0],[[300,75],[300,250],[300,200],[300,100],[300,50],[250,250],[240,120],[1,1],"fluid"]],[[216,0],[[216,36],[200,50],[180,150],[168,28],[125,125],[120,60],[120,20],[88,31],[72,60],[1,1],"fluid"]],[[0,0],[[1,1],"fluid"]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: true,
            lazyLoadingPosition: 300,
            description: 'slot doładowywany dynamicznie na odsłonie newsa',
            isLazyLoadingMobile: true,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 300,
            sizes: [['300', '250']],
            floating: 0,
            disable: false,
            name: 'rectangle_news',
            zoneid: '',
            slotid: '',
        },
        {
            bidders: [
                {
                    __typename: 'Bidder',
                    name: 'criteo',
                    paramSets: [
                        {
                            desktop: false,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'networkId', value: 2697 }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'rtbhouse',
                    paramSets: [
                        {
                            desktop: false,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
                {
                    __typename: 'Bidder',
                    name: 'sspBC',
                    paramSets: [
                        {
                            desktop: false,
                            __typename: 'ParamSet',
                            mobile: true,
                            minWidth: null,
                            params: [{ name: 'publisherId', value: '449' }],
                            maxWidth: null,
                        },
                    ],
                    disabled: null,
                    priority: 0,
                },
            ],
            mapping:
                '[[[480,0],[]],[[360,0],[[320,125],[320,100],[320,50],[300,125],[300,100],[300,50],[1,1],"fluid"]],[[300,0],[[300,125],[300,100],[300,50],[1,1],"fluid"]],[[0,0],[[1,1],"fluid"]]]',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: false,
            lazyLoadingPosition: 151,
            description: 'Banner scrollowany, przypięty do dolnej krawędzi przeglądarki w wersji mobilnej serwisu(pogoda.interia.pl)',
            isLazyLoadingMobile: false,
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            prebid: true,
            lazyLoadingPositionMobile: 151,
            sizes: [
                ['300', '100'],
                ['300', '50'],
                ['320', '100'],
                ['320', '50'],
                ['320', '125'],
                ['300', '125'],
            ],
            floating: 0,
            disable: false,
            name: 'scroll_footer',
            zoneid: '',
            slotid: '',
        },
        {
            bidders: null,
            mapping: '[[[0,0],[[1,1]]]]',
            isLazyLoading: null,
            lazyLoadingPosition: null,
            description: 'sitebranding',
            isLazyLoadingMobile: null,
            outOfPage: false,
            isNative: false,
            adServer: 'ADOCEAN',
            lazyLoadingPositionMobile: null,
            sizes: [['1', '1']],
            floating: 0,
            disable: false,
            name: 'sitebranding',
            zoneid: null,
            slotid: 'adoceanhubwngtbxlgqo',
        },
        {
            bidders: null,
            mapping: '',
            isLazyLoading: null,
            lazyLoadingPosition: null,
            description: 'AdOcean - watermark',
            isLazyLoadingMobile: null,
            outOfPage: false,
            isNative: false,
            adServer: 'ADOCEAN',
            lazyLoadingPositionMobile: null,
            sizes: [],
            disable: false,
            name: 'watermark',
            zoneid: null,
            slotid: 'adoceanhubtonjfufllj',
        },
        {
            bidders: [],
            mapping: '',
            refreshAds: { __typename: 'AdsRefresh', interval: 30, enabled: true },
            isLazyLoading: false,
            lazyLoadingPosition: 0,
            description: 'Emisja w ramach działań dla InImage',
            outOfPage: false,
            isNative: false,
            adServer: 'DFP',
            sizes: [['1', '1']],
            disable: false,
            name: 'zdjecie',
            zoneid: '',
            slotid: '',
        },
    ],
    keywords: { ADOCEAN: 'default2022', DFP: 'default2022' },
    adPath: '44520695/17interia/default',
    refreshAds: { interval: 30, enabled: true },
    prebidsConfig: {
        priceGranularity: 'dense',
        enabledOrder: true,
        videoPrebidTemplates: [],
        buckets: [],
        __v: 0,
        currency: 'USD',
        slotPrebidTemplates: [
            {
                name: 'adform',
                paramSets: [{ desktop: true, mobile: false, minWidth: null, params: [{ name: 'mid', value: '1428531' }], maxWidth: null }],
                priority: 0,
            },
            {
                name: 'appnexus',
                paramSets: [
                    { desktop: true, mobile: false, minWidth: null, params: [{ name: 'placementId', value: '20864012' }], maxWidth: null },
                ],
                priority: 0,
            },
            {
                name: 'criteo',
                paramSets: [
                    { desktop: true, mobile: true, minWidth: null, params: [{ name: 'networkId', value: '2697' }], maxWidth: null },
                ],
                priority: 0,
            },
            {
                name: 'ix',
                paramSets: [{ desktop: true, mobile: false, minWidth: null, params: [{ name: 'siteId', value: '' }], maxWidth: null }],
                priority: 0,
            },
            {
                name: 'pubmatic',
                paramSets: [
                    {
                        desktop: true,
                        mobile: false,
                        minWidth: null,
                        params: [
                            { name: 'publisherId', value: '159674' },
                            { name: 'adSlot', value: '3901324' },
                        ],
                        maxWidth: null,
                    },
                ],
                priority: 0,
            },
            {
                name: 'rtbhouse',
                paramSets: [
                    {
                        desktop: true,
                        mobile: true,
                        minWidth: null,
                        params: [{ name: 'publisherId', value: 'oScqvFoFcqVeQET3ISu3' }],
                        maxWidth: null,
                    },
                ],
                priority: 0,
            },
            {
                name: 'rubicon',
                paramSets: [
                    {
                        desktop: true,
                        mobile: false,
                        minWidth: null,
                        params: [
                            { name: 'accountId', value: '25226' },
                            { name: 'siteId', value: '465446' },
                            { name: 'zoneId', value: '2740218' },
                        ],
                        maxWidth: null,
                    },
                ],
                priority: 0,
            },
            {
                name: 'smartadserver',
                paramSets: [
                    {
                        desktop: true,
                        mobile: false,
                        minWidth: null,
                        params: [
                            { name: 'siteId', value: '391409' },
                            { name: 'pageId', value: '1342943' },
                            { name: 'formatId', value: '96705' },
                        ],
                        maxWidth: null,
                    },
                ],
                priority: 0,
            },
            {
                name: 'sspBC',
                paramSets: [
                    { desktop: true, mobile: true, minWidth: null, params: [{ name: 'publisherId', value: '449' }], maxWidth: null },
                ],
                priority: 0,
            },
            {
                name: 'teads',
                paramSets: [
                    {
                        desktop: true,
                        mobile: false,
                        minWidth: null,
                        params: [
                            { name: 'pageId', value: '191962' },
                            { name: 'placementId', value: '207156' },
                        ],
                        maxWidth: null,
                    },
                ],
                priority: 0,
            },
        ],
        _id: { $oid: '5d3ff5188fc5d3001ad45cba' },
        priority: [
            { name: 'Criteo', priority: 10, value: 'criteo' },
            { name: 'Index Exchange', priority: 9, value: 'ix' },
            { name: 'WP_Partner (sspBC)', priority: 8, value: 'sspBC' },
            { name: 'Adform', priority: 7, value: 'adform' },
            { name: 'RTBHouse', priority: 6, value: 'rtbhouse' },
            { name: 'Smart (Equativ)', priority: 5, value: 'smartadserver' },
            { name: 'AppNexus (Xandr)', priority: 4, value: 'appnexus' },
            { name: 'PubMatic', priority: 3, value: 'pubmatic' },
            { name: 'Magnite (vel. Rubicon)', priority: 2, value: 'rubicon' },
            { name: 'Teads', priority: 1, value: 'teads' },
            { name: 'Xaxis', priority: 0, value: 'xhb' },
            { name: 'OpenX', priority: 0, value: 'openx' },
        ],
        timeout: 2000,
        enabled: true,
    },
    pid: 'body',
    url: 'ros.serwisy.interia.pl*',
    cid: 'INTERIA/default2022',
    master: 'hlswv8MhJ43l2Dyf0s4K..H6HvofRq95gUwxJJzzI.H.T7',
};

export default defaultConfig;
